import { useEffect } from "react";

/**
 * Fades/slides .reveal elements in as they scroll into view — the same
 * IntersectionObserver pattern every one of these pages' own <script>
 * block implemented individually. Centralized here so all pages behave
 * identically and a fix only has to happen once.
 */
export function useScrollReveal(threshold = 0.12) {
  useEffect(() => {
    const revealEls = document.querySelectorAll(".reveal, .reveal-stagger, .reveal-stagger-3d");
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("in");
            io.unobserve(e.target);
          }
        });
      },
      { threshold }
    );
    revealEls.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, [threshold]);
}